import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BrowserStorageTypeEnum, BrowserStorageValue } from '../../interfaces';
import { AuthService, BrowserStorageService } from '../../services';

let navigationAttempted = false;

export const requireUserSetupGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const browserStorageService = inject(BrowserStorageService);
    const verificationAttempt = browserStorageService.getItem(
        'verificationAttempt',
        BrowserStorageTypeEnum.LocalStorage,
    ) as BrowserStorageValue;

    if (verificationAttempt && !navigationAttempted) {
        navigationAttempted = true;

        router.navigate(['/', 'verify'], {
            queryParams: {
                hash: verificationAttempt.hash,
            },
        });

        return false;
    }

    return authService.me().pipe(
        map((me) => {
            if (!me || (me.profile.first_name && me.profile.last_name)) {
                return true;
            }

            router.navigate(['/', 'wizard', 'user'], {
                queryParams: {
                    requireUserData: true,
                    userId: me.hash,
                    userGroupType: route.queryParamMap.get('userGroupType'),
                },
            });

            return false;
        }),
        catchError(() => {
            router.navigate(['/login']);
            return of(false);
        }),
    );
};
